function buildProductCartPayload(formData) {
  const deviceId = Number(formData.get('id'));
  const quantity = Number(formData.get('quantity') || 1);

  if (!Number.isSafeInteger(deviceId) || deviceId <= 0) throw new Error('Invalid device variant');
  if (!Number.isSafeInteger(quantity) || quantity <= 0) throw new Error('Invalid quantity');

  const device = { id: deviceId, quantity };
  const properties = {};
  for (const [name, value] of formData.entries()) {
    const match = name.match(/^properties\[(.+)\]$/);
    if (match) properties[match[1]] = value;
  }
  if (Object.keys(properties).length) device.properties = properties;

  const sellingPlan = formData.get('selling_plan');
  if (sellingPlan) device.selling_plan = Number(sellingPlan);

  const items = [device];
  for (const addOnId of formData.getAll('items[][id]')) {
    const id = Number(addOnId);
    if (Number.isSafeInteger(id) && id > 0) items.push({ id, quantity: 1 });
  }
  return { items };
}

function buildGiftCartPayload(formData, giftVariantId) {
  const payload = buildProductCartPayload(formData);
  const device = payload.items[0];
  const giftId = Number(giftVariantId);
  if (!Number.isSafeInteger(giftId) || giftId <= 0) throw new Error('Select a gift');
  if (giftId === device.id) throw new Error('Gift must be different from the device');
  payload.items.splice(1, 0, {
    id: giftId, quantity: device.quantity, parent_id: device.id, properties: { _xteink_gift: 'true' },
  });
  return payload;
}

function getGiftCartItemKeys(items, deviceVariantId, giftVariantId) {
  const device = items.find((item) => String(item.id) === String(deviceVariantId));
  const gift = items.find(
    (item) => String(item.id) === String(giftVariantId) && item.parent_relationship?.parent_key === device?.key
  ) || items.find((item) => String(item.id) === String(giftVariantId) && item.properties?._xteink_gift === 'true');
  return [...new Set([device, gift, ...items].map((item) => item?.key).filter(Boolean))];
}

if (typeof module !== 'undefined' && module.exports) module.exports = { buildProductCartPayload, buildGiftCartPayload, getGiftCartItemKeys };
